module.exports = __webpack_public_path__ + "73b6e7c2d7d2866f184470641939c7ac.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/twitter.png
// module id = 967
// module chunks = 2